import { render, staticRenderFns } from "./PPortNetwork.vue?vue&type=template&id=6a96ae2e&scoped=true"
import script from "./PPortNetwork.vue?vue&type=script&lang=js"
export * from "./PPortNetwork.vue?vue&type=script&lang=js"
import style0 from "./PPortNetwork.vue?vue&type=style&index=0&id=6a96ae2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a96ae2e",
  null
  
)

export default component.exports